/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import connect from 'SalesContentIndexUI/data/redux/connect';
import { getIsCustomTeamOptionDisabled, getAdditionalOptions } from 'SalesContentIndexUI/data/redux/selectors/viewFiltersSelectors';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import UsersAndTeamsSelect from 'ui-asset-management-lib/components/tableFilters/UsersAndTeamsSelect';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { fetchOwnersAndTeams } from 'SalesContentIndexUI/api/OwnersApi';
import { jsx as _jsx } from "react/jsx-runtime";
const parseTypeAndId = selectedViewFilterId => {
  const userAndTeamRegExp = /(USER|TEAM)-(\d+)/;
  if (userAndTeamRegExp.test(selectedViewFilterId)) {
    return {
      selectedType: userAndTeamRegExp.exec(selectedViewFilterId)[1],
      selectedId: Number(userAndTeamRegExp.exec(selectedViewFilterId)[2])
    };
  }
  return {
    selectedId: selectedViewFilterId
  };
};
const normalizeSelectValue = value => {
  switch (value) {
    case DefaultFilterNames.CREATED_BY_ME:
    case DefaultFilterNames.OWNED_BY_ME:
      return DefaultFilterNames.ASSIGNED_TO_USER;
    case DefaultFilterNames.CREATED_BY_MY_TEAM:
    case DefaultFilterNames.OWNED_BY_MY_TEAM:
      return DefaultFilterNames.ASSIGNED_TO_USERS_TEAM;
    default:
      return value;
  }
};
const normalizeSelection = (selection, useOwnerViewFilters) => {
  switch (selection.id) {
    case DefaultFilterNames.ASSIGNED_TO_USER:
      return Object.assign({}, selection, {
        id: useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_ME : DefaultFilterNames.CREATED_BY_ME
      });
    case DefaultFilterNames.ASSIGNED_TO_USERS_TEAM:
      return Object.assign({}, selection, {
        id: useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_MY_TEAM : DefaultFilterNames.CREATED_BY_MY_TEAM
      });
    default:
      return selection;
  }
};
const IndexTableViewFilters = ({
  setViewFilter,
  looseItemContentType,
  selectedViewFilterId,
  isCustomTeamOptionDisabled,
  additionalOptions,
  useOwnerViewFilters
}) => {
  const [ownersAndTeams, setOwnersAndTeams] = useState();
  const selectionRef = useRef();
  selectionRef.current = parseTypeAndId(selectedViewFilterId);
  useEffect(() => {
    const {
      selectedId,
      selectedType
    } = selectionRef.current;
    fetchOwnersAndTeams(looseItemContentType, selectedId, selectedType).then(response => {
      setOwnersAndTeams(response);
    });
  }, [looseItemContentType]);
  if (!ownersAndTeams) return null;
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.filter.owner"
    }),
    children: /*#__PURE__*/_jsx(UsersAndTeamsSelect, {
      buttonUse: "link",
      "data-selenium-test": "sales-content-index-table-view-filter",
      assetTypeDisplayName: I18n.text(`salesContentIndexUI.filter.displayName.${looseItemContentType}`),
      teams: ownersAndTeams.teams,
      users: ownersAndTeams.owners,
      onChange: selectedFilter => setViewFilter(normalizeSelection(selectedFilter, useOwnerViewFilters)),
      showUnassigned: false,
      searchPlaceholder: I18n.text('salesContentIndexUI.filter.searchPlaceholder'),
      value: normalizeSelectValue(selectionRef.current.selectedId),
      customTeamOptionDisabled: isCustomTeamOptionDisabled,
      additionalOptions: additionalOptions
    })
  });
};
IndexTableViewFilters.propTypes = {
  setViewFilter: PropTypes.func.isRequired,
  looseItemContentType: PropTypes.string.isRequired,
  isCustomTeamOptionDisabled: PropTypes.bool,
  selectedViewFilterId: PropTypes.string.isRequired,
  additionalOptions: PropTypes.array,
  useOwnerViewFilters: PropTypes.bool
};
export default connect(state => {
  return {
    isCustomTeamOptionDisabled: getIsCustomTeamOptionDisabled(state),
    viewFilters: state.viewFilters,
    additionalOptions: getAdditionalOptions(state)
  };
}, {})(IndexTableViewFilters);